import React from 'react'
import { useTranslation } from "react-i18next"

import { useFieldValue } from "components/form/input/NestedField"
import FormRow from "components/form/FormRow"
import TextInput from 'components/form/input/TextInput'

import { Box, Button, IconButton, Typography } from "@mui/material"
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'

function CardProduct({ ...props }) {
    return (
        <FormRow
            sx={{
                display: 'flex',
                justifyContent: "center",
                backgroundColor: "rgba(125,125,125,0.2)",
                mb: 1,
                p: 1,
            }}
        >
            <TextInput
                name="description"
                label="Descrição"
                value={props.product.description}
                multiline
                onChange={e => { props.updateProductDescription(e.target.value) }}
            />
            <IconButton aria-label="delete" onClick={props.deleteProduct}>
                <DeleteIcon />
            </IconButton>
        </FormRow>
    )
}

export default function TableOtherProducts({ fieldName, fieldLabel }) {
    const { t } = useTranslation()
    const [addedProductsReal, setAddedProducts] = useFieldValue(fieldName)
    let addedProducts = []    
    if (addedProductsReal) {
        if (Array.isArray(addedProductsReal)) {
            addedProducts = addedProductsReal
        } else {
            addedProducts = [{ description: addedProductsReal }]
        }
    }

    const newProduct = (product) => {
        setAddedProducts([{ description: '' }, ...addedProducts])
    }

    const deleteProduct = (index) => {
        let array = [...addedProducts]
        array.splice(index, 1)
        setAddedProducts(array)
    }

    const updateProductDescription = (index, description) => {
        let array = [...addedProducts]
        array[index].description = description
        setAddedProducts(array)
    }

    return (
        <Box sx={{ display: "flex", flexBasis: "100%", flexDirection: "column" }}>
            <FormRow
                sx={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'nowrap'
                }}
            >
                <Typography variant="h6">{fieldLabel}</Typography>
                {typeof addedProducts === "object"
                    ? < Box sx={{ display: "flex" }}>
                        <Button
                            onClick={newProduct}
                            sx={{ m: 1, alignSelf: 'flex-end' }}
                            startIcon={<AddIcon />}
                        >
                            {t('Nova Sugestão')}
                        </Button>
                    </Box>
                    : <></>
                }
            </FormRow >
            {typeof addedProducts === "object"
                ? <>
                    {addedProducts.length !== 0
                        ? addedProducts.map((product, index) => (
                            <CardProduct
                                key={index} // Each child in a list should have a unique "key" prop
                                product={product}
                                deleteProduct={() => deleteProduct(index)}
                                updateProductDescription={description => updateProductDescription(index, description)}
                            />
                        ))
                        : <FormRow sx={{ display: "flex", justifyContent: 'center' }}>
                            <Typography sx={{ color: 'text.disabled' }}>- {t('Nenhuma Sugestão Adicionada')} -</Typography>
                        </FormRow>
                    }
                </>
                : <TextInput
                    name={fieldName}
                    label={fieldLabel}
                    multiline
                />
            }
        </Box >
    )
}
